import { api } from '../../core/network/api';

/**
 * Sprays — a marketplace cosmetic. `SpraysController`'s three routes (backend work in flight
 * alongside this file; contract only, per the marketplace rebuild brief). Equip is global, same
 * shape as a charm or a player card: one spray worn at a time, not per loadout slot.
 */
export interface SprayEntry {
  id: number;
  name: string;
  description: string;
  /** Icon-atlas key under `/game/ui/cards/<glyph>.png` — a single-colour glyph, tinted via
   * `tint` rather than shipped pre-coloured (see `spraySwatch` in `marketplace-tile.ts`). */
  glyph: string;
  /** 0xrrggbb. */
  tint: number;
  priceCoins: number;
  currency: 'SOFT' | 'PREMIUM';
  owned: boolean;
  equipped: boolean;
  affordable: boolean;
}

export interface SprayCatalogueView {
  equippedSpray: number;
  sprays: SprayEntry[];
}

/** `GET /sprays`. */
export const fetchSpraysCatalogue = () => api.get<SprayCatalogueView>('/sprays');

/** `POST /sprays/purchase`. */
export const purchaseSpray = (spray: number) => api.post<{ equippedSpray: number }>('/sprays/purchase', { spray });

/** `POST /sprays/equip` — `spray: 0` takes it off; always a legal value. */
export const equipSpray = (spray: number) => api.post<{ equippedSpray: number }>('/sprays/equip', { spray });
